/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */

import React from 'react';

import { IPromoBannerViewProps } from './dobbies-cta-section';
// import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import MsDyn365 from '@msdyn365-commerce/core';
declare global {
    interface Window {
        Trustpilot: any;
    }
}

const PromoBannerView: React.FC<IPromoBannerViewProps> = props => {
    const ref = React.useRef(null);

    /* Following function checks device type and handles state accordingly if view changes, state will be updated and view will be shown according to device. */
    const isiPadView = (): boolean => {
        if ((MsDyn365.isBrowser && window) !== undefined && MsDyn365.isBrowser && window && window.innerWidth) {
            if (window.innerWidth >= 767 && window.innerWidth <= 1210) {
                return true;
            }
        }
        return false;
    };

    const isMobileView = (): boolean => {
        if ((MsDyn365.isBrowser && window) !== undefined && MsDyn365.isBrowser && window && window.innerWidth) {
            if (window.innerWidth <= 767) {
                return true;
            }
        }
        return false;
    };

    React.useEffect(() => {
        if (window.Trustpilot) {
            window.Trustpilot.loadFromElement(ref.current, true);
        }
    }, []);

    const sanitizeLinkText = (text: string | undefined): string => {
        if (!text) {
            return '';
        }
        return text.toLocaleLowerCase().replace(' ', '-');
    };

    if (!MsDyn365.isBrowser || !window) {
        return <></>;
    }
    if (isiPadView()) {
        return (
            <>
                <div className='ms-cta-section ipad mb-10' id='' data-m-t='ms-cta-section' data-m-layout='mediumWidth' role='banner'>
                    <div className='row'>
                        <Carousel autoPlay showIndicators={false} showArrows={true} showStatus={false}>
                            <div className='carousel-group'>
                                <div className={`cta-m-column ${sanitizeLinkText(props.config.ctaTilesLeft?.linkText)}`}>
                                    <div className='cta-image'>
                                        <img
                                            src={props.config.ctaTilesLeft?.image?.src}
                                            alt={props.config.ctaTilesLeft?.linkText}
                                            width={60}
                                            height={60}
                                        />
                                    </div>
                                    <div className='cta-m-details'>
                                        <a href={props.config.ctaTilesLeft?.linkUrl.destinationUrl}>
                                            {' '}
                                            <h6>{props.config.ctaTilesLeft?.linkText}</h6>
                                        </a>
                                        <p>{props.config.ctaTilesLeft?.ariaLabel}</p>
                                    </div>
                                </div>
                                <div className={`cta-m-column ${sanitizeLinkText(props.config.ctaTilesCenter?.linkText)}`}>
                                    <div className='cta-image'>
                                        <img
                                            src={props.config.ctaTilesCenter?.image?.src}
                                            alt={props.config.ctaTilesCenter?.linkText}
                                            width={60}
                                            height={60}
                                        />
                                    </div>
                                    <div className='cta-m-details'>
                                        <a href={props.config.ctaTilesCenter?.linkUrl.destinationUrl}>
                                            {' '}
                                            <h6>{props.config.ctaTilesCenter?.linkText}</h6>
                                        </a>
                                        <p>{props.config.ctaTilesCenter?.ariaLabel}</p>
                                    </div>
                                </div>

                                <div className={`cta-m-column ${sanitizeLinkText(props.config.ctaTilesRight?.linkText)}`}>
                                    <div className='cta-image'>
                                        <img
                                            src={props.config.ctaTilesRight?.image?.src}
                                            alt={props.config.ctaTilesRight?.linkText}
                                            width={60}
                                            height={60}
                                        />
                                    </div>
                                    <div className='cta-m-details'>
                                        <a href={props.config.ctaTilesRight?.linkUrl.destinationUrl}>
                                            {' '}
                                            <h6>{props.config.ctaTilesRight?.linkText}</h6>
                                        </a>
                                        <p>{props.config.ctaTilesRight?.ariaLabel}</p>
                                    </div>
                                </div>
                            </div>
                            <div className='carousel-group'>
                                <div className={`cta-m-column ${sanitizeLinkText(props.config.ctaTilesCenter?.linkText)}`} data-nosnippet>
                                    <div className='cta-image'>
                                        <img
                                            src={props.config.ctaTilesCenter?.image?.src}
                                            alt={props.config.ctaTilesCenter?.linkText}
                                            width={60}
                                            height={60}
                                        />
                                    </div>
                                    <div className='cta-m-details'>
                                        <a href={props.config.ctaTilesCenter?.linkUrl.destinationUrl}>
                                            {' '}
                                            <h6>{props.config.ctaTilesCenter?.linkText}</h6>
                                        </a>
                                        <p>{props.config.ctaTilesCenter?.ariaLabel}</p>
                                    </div>
                                </div>

                                <div className={`cta-m-column ${sanitizeLinkText(props.config.ctaTilesRight?.linkText)}`}>
                                    <div className='cta-image'>
                                        <img
                                            src={props.config.ctaTilesRight?.image?.src}
                                            alt={props.config.ctaTilesRight?.linkText}
                                            width={60}
                                            height={60}
                                        />
                                    </div>
                                    <div className='cta-m-details'>
                                        <a href={props.config.ctaTilesRight?.linkUrl.destinationUrl}>
                                            {' '}
                                            <h6>{props.config.ctaTilesRight?.linkText}</h6>
                                        </a>
                                        <p>{props.config.ctaTilesRight?.ariaLabel}</p>
                                    </div>
                                </div>
                                <div className={`cta-m-column ${sanitizeLinkText(props.config.ctaFourthTile?.linkText)}`}>
                                    <div className='cta-image'>
                                        <img
                                            src={props.config.ctaFourthTile?.image?.src}
                                            alt={props.config.ctaFourthTile?.linkText}
                                            width={60}
                                            height={60}
                                        />
                                    </div>
                                    <div className='cta-m-details'>
                                        <a href={props.config.ctaFourthTile?.linkUrl.destinationUrl}>
                                            {' '}
                                            <h6>{props.config.ctaFourthTile?.linkText}</h6>
                                        </a>
                                        <p>{props.config.ctaFourthTile?.ariaLabel}</p>
                                    </div>
                                </div>
                            </div>
                        </Carousel>
                    </div>
                </div>
            </>
        );
    } else if (!isMobileView()) {
        return (
            <>
                <div className='ms-cta-section' id='' data-m-t='ms-cta-section' data-m-layout='mediumWidth' role='banner'>
                    <div className='container'>
                        <div className='row cta-row'>
                            {props.config.ctaTilesLeft?.linkText && (
                                <>
                                    <div
                                        className={`cta-column ${props.config.ctaTilesLeft?.linkText
                                            .toLocaleLowerCase()
                                            .replace(' ', '-')}`}
                                    >
                                        <div className='cta-image'>
                                            <img
                                                src={props.config.ctaTilesLeft?.image?.src}
                                                alt={props.config.ctaTilesLeft?.linkText}
                                                width={50}
                                                height={50}
                                            />
                                        </div>
                                        <div className='cta-details'>
                                            <a href={props.config.ctaTilesLeft?.linkUrl.destinationUrl}>
                                                {' '}
                                                <h6>{props.config.ctaTilesLeft?.linkText}</h6>
                                            </a>
                                            <p>{props.config.ctaTilesLeft?.ariaLabel}</p>
                                        </div>
                                    </div>
                                </>
                            )}
                            {props.config.ctaTilesCenter?.linkText && (
                                <>
                                    <div
                                        className={`cta-column ${props.config.ctaTilesCenter?.linkText
                                            .toLocaleLowerCase()
                                            .replace(' ', '-')}`}
                                    >
                                        <div className='cta-image'>
                                            <img
                                                src={props.config.ctaTilesCenter?.image?.src}
                                                alt={props.config.ctaTilesCenter?.linkText}
                                                width={50}
                                                height={50}
                                            />
                                        </div>
                                        <div className='cta-details'>
                                            <a href={props.config.ctaTilesCenter?.linkUrl.destinationUrl}>
                                                {' '}
                                                <h6>{props.config.ctaTilesCenter?.linkText}</h6>
                                            </a>
                                            <p>{props.config.ctaTilesCenter?.ariaLabel}</p>
                                        </div>
                                    </div>
                                </>
                            )}
                            {props.config.ctaTilesRight?.linkText && (
                                <>
                                    <div
                                        className={`cta-column ${props.config.ctaTilesRight?.linkText
                                            .toLocaleLowerCase()
                                            .replace(' ', '-')}`}
                                    >
                                        <div className='cta-image'>
                                            <img
                                                src={props.config.ctaTilesRight?.image?.src}
                                                alt={props.config.ctaTilesRight?.linkText}
                                                width={50}
                                                height={50}
                                            />
                                        </div>
                                        <div className='cta-details'>
                                            <a href={props.config.ctaTilesRight?.linkUrl.destinationUrl}>
                                                {' '}
                                                <h6>{props.config.ctaTilesRight?.linkText}</h6>
                                            </a>
                                            <p>{props.config.ctaTilesRight?.ariaLabel}</p>
                                        </div>
                                    </div>
                                </>
                            )}
                            {props.config.ctaFourthTile?.linkText && (
                                <>
                                    <div
                                        className={`cta-column ${props.config.ctaFourthTile?.linkText
                                            .toLocaleLowerCase()
                                            .replace(' ', '-')}`}
                                    >
                                        <div className='cta-image'>
                                            <img
                                                src={props.config.ctaFourthTile?.image?.src}
                                                alt={props.config.ctaFourthTile?.linkText}
                                                width={50}
                                                height={50}
                                            />
                                        </div>
                                        <div className='cta-details'>
                                            <a href={props.config.ctaFourthTile?.linkUrl.destinationUrl}>
                                                {' '}
                                                <h6>{props.config.ctaFourthTile?.linkText}</h6>
                                            </a>
                                            <p>{props.config.ctaFourthTile?.ariaLabel}</p>
                                        </div>
                                    </div>
                                </>
                            )}
                            {props.config.trustPilot?.dataTemplateId && (
                                <>
                                    <div className='cta-column'>
                                        {/* <h1>{props.config.trustPilot?.titleTrustpilot}</h1> */}
                                        <div
                                            ref={ref}
                                            className={
                                                props.config.trustPilot?.classname
                                                    ? props.config.trustPilot?.classname
                                                    : 'trustpilot-widget'
                                            }
                                            data-locale={
                                                props.config.trustPilot?.dataLocale ? props.config.trustPilot?.dataLocale : 'en-GB'
                                            }
                                            data-template-id={
                                                props.config.trustPilot?.dataTemplateId
                                                    ? props.config.trustPilot?.dataTemplateId
                                                    : '5419b732fbfb950b10de65e5'
                                            }
                                            data-businessunit-id={
                                                props.config.trustPilot?.dataBusinessunitId
                                                    ? props.config.trustPilot?.dataBusinessunitId
                                                    : '4b1d7776000064000504d8b0'
                                            }
                                            data-style-height={
                                                props.config.trustPilot?.dataStyleHeight ? props.config.trustPilot?.dataStyleHeight : '24px'
                                            }
                                            data-style-width={
                                                props.config.trustPilot?.dataStyleWidth ? props.config.trustPilot?.dataStyleWidth : '100%'
                                            }
                                            data-theme={props.config.trustPilot?.dataTheme ? props.config.trustPilot?.dataTheme : 'light'}
                                            data-text-color={
                                                props.config.trustPilot.dataTextColor
                                                    ? props.config.trustPilot.dataTextColor
                                                    : 'transparent'
                                            }
                                        >
                                            <a
                                                href='https://uk.trustpilot.com/review/www.dobbies.com'
                                                target='_blank'
                                                rel='noopener noreferrer'
                                            >
                                                Trustpilot
                                            </a>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </>
        );
    } else {
        return (
            <>
                {props.config.trustPilot?.dataTemplateId ? (
                    <div className='ms-cta-section mb-10' id='' data-m-t='ms-cta-section' data-m-layout='mediumWidth' role='banner'>
                        <div className='row'>
                            <Carousel autoPlay showIndicators={false} showArrows={true} showStatus={false}>
                                <div
                                    className={`cta-m-column ${props.config.ctaTilesLeft?.linkText?.toLocaleLowerCase().replace(' ', '-')}`}
                                >
                                    <div className='cta-image'>
                                        <img
                                            src={props.config.ctaTilesLeft?.image?.src}
                                            alt={props.config.ctaTilesLeft?.linkText}
                                            width={60}
                                            height={60}
                                        />
                                    </div>
                                    <div className='cta-m-details'>
                                        <a href={props.config.ctaTilesLeft?.linkUrl.destinationUrl}>
                                            {' '}
                                            <h6>{props.config.ctaTilesLeft?.linkText}</h6>
                                        </a>
                                        <p>{props.config.ctaTilesLeft?.ariaLabel}</p>
                                    </div>
                                </div>
                                <div
                                    className={`cta-m-column ${props.config.ctaTilesCenter?.linkText
                                        ?.toLocaleLowerCase()
                                        .replace(' ', '-')}`}
                                >
                                    <div className='cta-image'>
                                        <img
                                            src={props.config.ctaTilesCenter?.image?.src}
                                            alt={props.config.ctaTilesCenter?.linkText}
                                            width={60}
                                            height={60}
                                        />
                                    </div>
                                    <div className='cta-m-details'>
                                        <a href={props.config.ctaTilesCenter?.linkUrl.destinationUrl}>
                                            {' '}
                                            <h6>{props.config.ctaTilesCenter?.linkText}</h6>
                                        </a>
                                        <p>{props.config.ctaTilesCenter?.ariaLabel}</p>
                                    </div>
                                </div>

                                <div
                                    className={`cta-m-column ${props.config.ctaTilesRight?.linkText
                                        ?.toLocaleLowerCase()
                                        .replace(' ', '-')}`}
                                >
                                    <div className='cta-image'>
                                        <img
                                            src={props.config.ctaTilesRight?.image?.src}
                                            alt={props.config.ctaTilesRight?.linkText}
                                            width={60}
                                            height={60}
                                        />
                                    </div>
                                    <div className='cta-m-details'>
                                        <a href={props.config.ctaTilesRight?.linkUrl.destinationUrl}>
                                            {' '}
                                            <h6>{props.config.ctaTilesRight?.linkText}</h6>
                                        </a>
                                        <p>{props.config.ctaTilesRight?.ariaLabel}</p>
                                    </div>
                                </div>
                                <div
                                    className={`cta-m-column ${props.config.ctaFourthTile?.linkText
                                        ?.toLocaleLowerCase()
                                        .replace(' ', '-')}`}
                                >
                                    <div className='cta-image'>
                                        <img
                                            src={props.config.ctaFourthTile?.image?.src}
                                            alt={props.config.ctaFourthTile?.linkText}
                                            width={60}
                                            height={60}
                                        />
                                    </div>
                                    <div className='cta-m-details'>
                                        <a href={props.config.ctaFourthTile?.linkUrl.destinationUrl}>
                                            {' '}
                                            <h6>{props.config.ctaFourthTile?.linkText}</h6>
                                        </a>
                                        <p>{props.config.ctaFourthTile?.ariaLabel}</p>
                                    </div>
                                </div>
                                <div className='cta-m-column'>
                                    {/* <h1>{props.config.trustPilot?.titleTrustpilot}</h1> */}
                                    <div
                                        ref={ref}
                                        className={
                                            props.config.trustPilot?.classname ? props.config.trustPilot?.classname : 'trustpilot-widget'
                                        }
                                        data-locale={props.config.trustPilot?.dataLocale ? props.config.trustPilot?.dataLocale : 'en-GB'}
                                        data-template-id={
                                            props.config.trustPilot?.dataTemplateId
                                                ? props.config.trustPilot?.dataTemplateId
                                                : '5419b732fbfb950b10de65e5'
                                        }
                                        data-businessunit-id={
                                            props.config.trustPilot?.dataBusinessunitId
                                                ? props.config.trustPilot?.dataBusinessunitId
                                                : '4b1d7776000064000504d8b0'
                                        }
                                        data-style-height={
                                            props.config.trustPilot?.dataStyleHeight ? props.config.trustPilot?.dataStyleHeight : '24px'
                                        }
                                        data-style-width={
                                            props.config.trustPilot?.dataStyleWidth ? props.config.trustPilot?.dataStyleWidth : '100%'
                                        }
                                        data-theme={props.config.trustPilot?.dataTheme ? props.config.trustPilot?.dataTheme : 'light'}
                                        data-text-color={
                                            props.config.trustPilot?.dataTextColor ? props.config.trustPilot.dataTextColor : 'transparent'
                                        }
                                    >
                                        <a
                                            href='https://uk.trustpilot.com/review/www.dobbies.com'
                                            target='_blank'
                                            rel='noopener noreferrer'
                                        >
                                            Trustpilot
                                        </a>
                                    </div>
                                </div>
                            </Carousel>
                        </div>
                    </div>
                ) : (
                    <div className='ms-cta-section two mb-10' id='' data-m-t='ms-cta-section' data-m-layout='mediumWidth' role='banner'>
                        <div className='row'>
                            <Carousel autoPlay showIndicators={false} showArrows={true} showStatus={false}>
                                <div
                                    className={`cta-m-column ${props.config.ctaTilesLeft?.linkText?.toLocaleLowerCase().replace(' ', '-')}`}
                                >
                                    <div className='cta-image'>
                                        <img
                                            src={props.config.ctaTilesLeft?.image?.src}
                                            alt={props.config.ctaTilesLeft?.linkText}
                                            width={60}
                                            height={60}
                                        />
                                    </div>
                                    <div className='cta-m-details'>
                                        <a href={props.config.ctaTilesLeft?.linkUrl.destinationUrl}>
                                            {' '}
                                            <h6>{props.config.ctaTilesLeft?.linkText}</h6>
                                        </a>
                                        <p>{props.config.ctaTilesLeft?.ariaLabel}</p>
                                    </div>
                                </div>
                                <div
                                    className={`cta-m-column ${props.config.ctaTilesCenter?.linkText
                                        ?.toLocaleLowerCase()
                                        .replace(' ', '-')}`}
                                >
                                    <div className='cta-image'>
                                        <img
                                            src={props.config.ctaTilesCenter?.image?.src}
                                            alt={props.config.ctaTilesCenter?.linkText}
                                            width={60}
                                            height={60}
                                        />
                                    </div>
                                    <div className='cta-m-details'>
                                        <a href={props.config.ctaTilesCenter?.linkUrl.destinationUrl}>
                                            {' '}
                                            <h6>{props.config.ctaTilesCenter?.linkText}</h6>
                                        </a>
                                        <p>{props.config.ctaTilesCenter?.ariaLabel}</p>
                                    </div>
                                </div>

                                <div
                                    className={`cta-m-column ${props.config.ctaTilesRight?.linkText
                                        ?.toLocaleLowerCase()
                                        .replace(' ', '-')}`}
                                >
                                    <div className='cta-image'>
                                        <img
                                            src={props.config.ctaTilesRight?.image?.src}
                                            alt={props.config.ctaTilesRight?.linkText}
                                            width={60}
                                            height={60}
                                        />
                                    </div>
                                    <div className='cta-m-details'>
                                        <a href={props.config.ctaTilesRight?.linkUrl.destinationUrl}>
                                            {' '}
                                            <h6>{props.config.ctaTilesRight?.linkText}</h6>
                                        </a>
                                        <p>{props.config.ctaTilesRight?.ariaLabel}</p>
                                    </div>
                                </div>
                                <div
                                    className={`cta-m-column ${props.config.ctaFourthTile?.linkText
                                        ?.toLocaleLowerCase()
                                        .replace(' ', '-')}`}
                                >
                                    <div className='cta-image'>
                                        <img
                                            src={props.config.ctaFourthTile?.image?.src}
                                            alt={props.config.ctaFourthTile?.linkText}
                                            width={60}
                                            height={60}
                                        />
                                    </div>
                                    <div className='cta-m-details'>
                                        <a href={props.config.ctaFourthTile?.linkUrl.destinationUrl}>
                                            {' '}
                                            <h6>{props.config.ctaFourthTile?.linkText}</h6>
                                        </a>
                                        <p>{props.config.ctaFourthTile?.ariaLabel}</p>
                                    </div>
                                </div>
                            </Carousel>
                        </div>
                    </div>
                )}
            </>
        );
    }
};
export default PromoBannerView;
